// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-8dccd3b8] {\n  border-radius: 100px;\n}\n.field.is-grouped[data-v-8dccd3b8] {\n  justify-content: flex-end;\n}", ""]);
// Exports
module.exports = exports;
